import { useQuery } from '@tanstack/react-query';
import { learnerKeys } from './learnerKeys';
import { getProfile } from '../../api/me';

/**
 * Loads the signed-in member's learner profile from `GET /me/profile`. This is
 * the source of the org-assignment fields (`role_name`, `department_name`,
 * `location_name`) that the unified `useAuth().user` doesn't carry.
 */
export function useLearnerProfile() {
  return useQuery({
    queryKey: learnerKeys.profile,
    queryFn: getProfile,
  });
}
